module.exports = __webpack_public_path__ + "img/main.feac924f.svg";